//import React, { useState } from 'react';

import ChatHistory from './chat-history';
import { SupportChatChat } from '../models/support-chat-chat';

import './styles.less';

export type ChatMessagesAreaComponentProps = {
  userType: number;
  selectedChat: SupportChatChat | null;
};

const ChatMessagesArea = ({ userType, selectedChat }: ChatMessagesAreaComponentProps) => {
  //const [selectedNewChatItem, setSelectedNewChatItem] = useState(selectedChat);

  //const [makeClearData, setMakeClearData] = useState({ clear: false });

  return (
    //to change
    <div className="my-chatstyle">
      <ChatHistory userType={userType} selectedNewChatItem={selectedChat} />
    </div>
  );
};

export default ChatMessagesArea;
